import { api } from './api';
import { ITheme } from './types.api';

interface ThemesResponse {
  themes: ITheme[];
}

export const chatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getThemeMessages: builder.query<ThemesResponse, any>({
      query: () => ({
        url: '/receiveThemes',
      }),
    }),

    getMessages: builder.mutation<any, any>({
      query: (body) => ({
        url: '/receiveMessages',
        method: 'POST',
        body,
      }),
    }),

    getCountMessages: builder.query<unknown, void>({
      query: () => ({
        url: '/countMessages',
      }),
    }),

    sendMessage: builder.mutation<
      any,
      { message: string; fileData: string; fileName: string; id: string }
    >({
      query: (body) => ({
        url: '/sendMessage',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetMessagesMutation,
  useSendMessageMutation,
  useGetCountMessagesQuery,
  useGetThemeMessagesQuery,
} = chatApi;
